var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCommentAltDots = function SvgCommentAltDots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8.561a.85.85 0 1 0 0 1.7.85.85 0 0 0 0-1.7m5.95-5.95H4.55A2.55 2.55 0 0 0 2 5.161v8.5a2.55 2.55 0 0 0 2.55 2.55h9.852l3.145 3.154a.85.85 0 0 0 .926.178.85.85 0 0 0 .527-.782v-13.6a2.55 2.55 0 0 0-2.55-2.55m.85 14.102-1.947-1.955a.85.85 0 0 0-.603-.247H4.55a.85.85 0 0 1-.85-.85v-8.5a.85.85 0 0 1 .85-.85h11.9a.85.85 0 0 1 .85.85zM7.1 8.56a.85.85 0 1 0 0 1.7.85.85 0 0 0 0-1.7m6.8 0a.85.85 0 1 0 0 1.7.85.85 0 0 0 0-1.7"
  })));
};
export default SvgCommentAltDots;